export default __webpack_public_path__ + "static/media/START_Injection.9792ed89.pdf";